import { combineReducers } from 'redux';
import { segmentsModalReducer } from './segments-modal/segments-modal.state';
import { currentSegmentsReducers } from './segments.state';
import { tagGroupsSegmentedReportReducer } from './tag-groups-segmented/tag-groups-segmented.state';

export const segmentsReducer = combineReducers({
    currentSegments: currentSegmentsReducers,
    modal: segmentsModalReducer,
    tagGroupsSegmented: tagGroupsSegmentedReportReducer,
});
